import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttachSurveyUssdComponent } from './modals/attach-survey-ussd/attach-survey-ussd.component';
import { AddRewardComponent } from './modals/add-reward/add-reward.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddSurveyModal } from './modals/add-survey/add-survey.component';
// import { AddSurveyComponent } from '../shared/features/add-survey/add-survey.component';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { EditRewardComponent } from './modals/edit-reward/edit-reward.component';



@NgModule({
  declarations: [
    AddRewardComponent,
    AttachSurveyUssdComponent,
    AddSurveyModal,
    EditRewardComponent, 
    // AddSurveyComponent,
  ],
  imports: [
    CommonModule,
    QRCodeModule,
    NgxQRCodeModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SharedModule { }
